import smHeaderIcon from "@assets/images/sm-logo-inverted.svg";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import AppHeaderContext from "../AppLayout/AppHeaderContext";

// export interface AppHeaderProps {
//     children: React.ReactNode;
// }
const useStyles = makeStyles(
  {
    appHeader: {
      backgroundColor: "#0030FF",
      height: "80px",
      left: 0,
      padding: "0",
      position: "fixed",
      right: 0,
      top: 0,
      zIndex: 999
    },
    appHeaderLogo: {
      "@media (max-width: 767px)": {
        padding: "0 0 0 20px",
        width: "70px"
      },
      // eslint-disable-next-line sort-keys
      "@media (max-width: 376px)": {
        padding: "0 0 0 10px",
        width: "50px"
      },

      alignItems: "center",
      // backgroundColor: "#2251a1",
      display: "flex",
      height: "100%",
      overflow: "hidden",
      padding: "0 20px"
    },
    appHeaderLogoImg: {
      "@media (max-width: 767px)": {
        height: "45px"
      },
      // eslint-disable-next-line sort-keys
      "@media (max-width: 376px)": {
        height: "40px"
      },
      height: "50px"
    }
  },
  { name: "CustomHeader" }
);

const CustomHeader: React.FC = props => {
  // const { children } = props;
  const classes = useStyles(props);

  return (
    <AppHeaderContext.Consumer>
      {anchor =>
        !anchor ? (
          <div className={classes.appHeader}>
            <div className={classes.appHeaderLogo}>
              <img className={classes.appHeaderLogoImg} src={smHeaderIcon} />
            </div>
            {/* {children} */}
          </div>
        ) : null
      }
    </AppHeaderContext.Consumer>
  );
};
CustomHeader.displayName = "CustomHeader";
export default CustomHeader;
